export function PageHeader() {
  return (
    <div className="name-container">
      <h1 className="name">Guy Pollack</h1>
      <div className="name-blinker"></div>
    </div>
  )
}